import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { merchantApi } from "@api";
import { ArrowLeft, ArrowLongRightIcon, ImageUploadIcon } from "@components";
import { PATH_HOME, _10MB } from "@configs";
import { IMemberType } from "@interfaces";
import { selectAuth, selectMerchant, setLoading } from "@redux";
import { formatMessage, useNotify } from "@utils";
import { Button, Input, Radio } from "antd";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const INITVALUE: IMemberType = {
    memberTypeNameId: "",
    userId: "",
    merchantId: "",
    imageUrl: "",
    studentId: "",
    id_card: "",
};

interface IType {
    typeName: string;
    _id: string;
}

export const PageMemberTypeUpload = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();
    //page redux
    const { userInfo } = useSelector(selectAuth);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { t } = useTranslation();
    const [receiptImg, setReceiptImg] = useState<any>("");
    const [imgFile, setImgFile] = useState<any>("");
    const { success, error, warning } = useNotify();
    const [typelist, setTypeList] = useState<IType[]>([]);
    const [value, setValue] = useState<IMemberType>(INITVALUE);
    const [pdpa, setPdpa] = useState<boolean>(false);
    const [step, setStep] = useState<number>(0);
    const [focusType, setFocusType] = useState<number>(0);
    //page state

    const inputRef = useRef();

    useEffect(() => {
        getTypeList();
    }, []);

    const getTypeList = async () => {
        let res = await merchantApi.getMemberType();
        setTypeList(res.data?.result?.MemberTypeConfig?.memberTypeName);
    };

    const changeImg = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) {
            setReceiptImg("");
            return;
        } else {
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setImgFile(e.target.files[0]);
            setReceiptImg(objectUrl);
        }
    };
    const clickType = (key: number) => {
        setFocusType(key);
        setStep(1);
    };

    const uploadImage = async (formData: FormData) => {
        try {
            const res = await merchantApi.uploadImage(formData);
            return res.data.publicUrl;
        } catch (err: any) {
            // const data = err.response.data;
            // const mess = Array.isArray(data.errors) ? data.errors[0] : data.message;
            error(formatMessage(err.response));
        } finally {
            dispatch(setLoading(false));
        }
    };
    const clickNext = () => {
        if (pdpa) {
            if (value?.id_card === "" || value?.studentId === "") {
                warning("Please fill form");
            } else {
                setStep(2);
            }
        } else {
            warning("Please confirm PDPA");
        }
    };

    const clickCamera = () => {
        setStep(3);
    };

    const handleConfirm = async () => {
        try {
            dispatch(setLoading(true));
            if (receiptImg !== "") {
                if (imgFile.size >= _10MB) {
                    error(t("validation.image.max_size"));
                    dispatch(setLoading(false));
                } else {
                    const formData = new FormData();
                    formData.append("file", imgFile);

                    let imgUrl = await uploadImage(formData);

                    // let payload: IUploadReceipt = {
                    //     merchantId: userInfo?.merchantId || "",
                    //     userId: userInfo?.contact?.userId || "",
                    //     userName: userInfo?.username || "",
                    //     userTel: userInfo?.phoneNumber || "",
                    //     imageUrl: imgUrl,
                    // };
                    let payload: IMemberType = {
                        memberTypeNameId: typelist[focusType]?._id || "",
                        userId: userInfo?._id || "",
                        merchantId: merchant?._id || "",
                        studentId: value?.studentId,
                        id_card: value?.id_card,
                        imageUrl: imgUrl,
                    };
                    await merchantApi.postMemberType(payload);
                    success(t("page.upload_receipt.success"));
                    // history.push(PATH_HOME);
                    setStep(4);
                }
            } else {
                error(t("page.upload_receipt.empty_error"));
            }
        } catch (err: any) {
            // const data = err.response.data;
            // const mess = Array.isArray(data.errors) ? data.errors[0] : data.message;
            error(formatMessage(err.response));
        } finally {
            dispatch(setLoading(false));
        }
    };
    const changeValue = (e: any) => {
        let arr = value;
        //@ts-ignore
        arr[e.target.id] = e.target.value;
        setValue({ ...arr });
    };

    return (
        <>
            {step === 0 && (
                <StyleStep0 themeColor={themes?.themeColor!}>
                    <h1>Please select Member Type</h1>
                    <div className="list-section">
                        {typelist?.map((tItem, tIndex) => {
                            return (
                                <div
                                    className="list-item"
                                    key={tIndex}
                                    onClick={() => clickType(tIndex)}
                                >
                                    {tItem?.typeName}
                                </div>
                            );
                        })}
                    </div>
                </StyleStep0>
            )}
            {step === 1 && (
                <StyledReceiptPage themeColor={themes?.themeColor!}>
                    <div className="step-logo">
                        {/* <div className="step">
                    <p>1</p>
                    <div>&nbsp;</div>
                    <p>2</p>
                </div> */}
                        <div className="logo">
                            <img src={merchant?.themes?.logoSmallUrl} />
                        </div>
                    </div>

                    <h1>
                        {/* {t("page.mem_type.create_title")} */}
                        Create {typelist[focusType]?.typeName} Member
                    </h1>

                    <p className="input-title">Full Name</p>
                    <Input value={userInfo?.fullName} className="field-input" disabled />
                    <p className="input-title">Phone Number</p>
                    <Input value={userInfo?.phoneNumber} className="field-input" disabled />
                    <p className="input-title">Nation ID</p>
                    <Input
                        value={value?.id_card}
                        className="field-input"
                        id="idCard"
                        onChange={changeValue}
                    />
                    <p className="input-title">{typelist[focusType]?.typeName} ID</p>
                    <Input
                        value={value?.studentId}
                        className="field-input"
                        id="studentId"
                        onChange={changeValue}
                    />
                    <div className="radio-section">
                        <Radio checked={pdpa} onClick={() => setPdpa(!pdpa)} />
                        <p className="radio-text">
                            ฉันยอมรับ
                            <span>เงื่อนไข และข้อตกลงการใช้บริการ</span>
                            ของทางบริษัท
                        </p>
                    </div>

                    <Button className="next-btn" onClick={clickNext}>
                        Next <ArrowLongRightIcon />
                    </Button>
                </StyledReceiptPage>
            )}
            {step === 2 && (
                <StyledExamplePage themeColor={themes?.themeColor!}>
                    <div className="title-section">
                        <ArrowLeft />
                        <h1>
                            {/* {t("page.mem_type.verify_title")} */}
                            Selfie indetity verifycation with {typelist[focusType]?.typeName} card
                        </h1>
                    </div>
                    <div className="verify-detail">
                        <img src="../images/verifyId.png" className="verify-img" />
                        <br />
                        <Button onClick={clickCamera} className="next-btn">
                            Selfie Verify {typelist[focusType]?.typeName} &nbsp;{" "}
                            <ArrowLongRightIcon />
                        </Button>
                    </div>
                </StyledExamplePage>
            )}
            {step === 3 && (
                <StyledStep3 themeColor={themes?.themeColor!}>
                    <input
                        //@ts-ignore
                        ref={inputRef}
                        type="file"
                        hidden
                        id="uploadImage"
                        onChange={changeImg}
                        accept="image/png, image/jpeg, image/jpg"
                    />
                    <div className="box-image">
                        {receiptImg === "" ? (
                            <div className="dont-have-img">
                                <label className="camera-text" htmlFor="uploadImage">
                                    <ImageUploadIcon color={themes?.themeColor!} />
                                    <p>
                                        + {t("page.upload_receipt.upload_text")}
                                        <span className="color-span">
                                            {t("page.upload_receipt.receipt")}
                                        </span>
                                    </p>
                                </label>
                            </div>
                        ) : (
                            <div className="have-img">
                                <label className="camera-text" htmlFor="uploadImage">
                                    <img src={receiptImg} />
                                </label>
                            </div>
                        )}
                    </div>
                    {/* <Camera /> */}
                    <Button onClick={handleConfirm} className="confirm-btn">
                        Confirm
                    </Button>
                </StyledStep3>
            )}
            {step === 4 && (
                <StyleStep4 themeColor={themes?.themeColor!}>
                    <p>
                        Register {typelist[focusType]?.typeName}
                        <br />
                        Member Success!
                    </p>
                    <Button onClick={() => history.push(PATH_HOME)}>Done</Button>
                </StyleStep4>
            )}
        </>
    );
};

const StyledReceiptPage = styled.div<{ themeColor: string }>`
    height: 100vh;
    padding: 20px;
    .step-logo {
        display: flex;
        justify-content: center;
        padding-bottom: 20px;
        .logo {
            background-color: pink;
            img {
                max-width: 60px;
                max-height: 60px;
            }
        }
    }
    h1 {
        font-size: 24px;
        font-weight: 500;
        color: ${(p) => p.themeColor};
        padding-bottom: 25px;
        border-bottom: 1px solid ${(p) => p.themeColor}70;
        text-align: center;
    }
    .view-btn {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
        display: flex;
        justify-content: center;
        padding-top: 12px;
    }
    .input-title {
        margin-bottom: 5px;
        margin-top: 15px;
        color: ${(p) => p.themeColor};
    }
    .input-receipt {
        height: 58px;
        padding-left: 20px;
        border: 1px solid ${(p) => p.themeColor}70;
        border-radius: 10px;
        outline: none;
    }
    .input-receipt:focus {
        outline: none;
        box-shadow: none;
    }

    .example-modal {
        position: fixed;
        bottom: 0px;
        width: 480px;
        max-width: 100vw;
        background-color: pink;
        height: 50vh;
        border-radius: 25px 25px 0 0;
    }
    .next-btn {
        width: 100%;
        height: 48px;
        color: white;
        background-color: ${(p) => p.themeColor};
        border-radius: 500px;
        margin-top: 40px;
    }
    .field-input {
        height: 58px;
        padding-left: 20px;
        border: 1px solid ${(p) => p.themeColor}70;
        border-radius: 10px;
        outline: none;
    }
    .field-input:focus {
        outline: none;
        box-shadow: none;
    }
    .radio-section {
        margin-top: 30px;
        display: flex;
        .radio-text {
            color: #9daaae;
            span {
                font-weight: 500;
                color: ${(p) => p.themeColor};
                padding: 0 10px;
                cursor: pointer;
            }
        }
    }
`;

const StyledExamplePage = styled.div<{ themeColor: string }>`
    .title-section {
        display: flex;
        justify-content: space-between;
        h1 {
            font-size: 20px;
            text-align: right;
            color: ${(p) => p.themeColor};
        }
    }
    .verify-detail {
        text-align: center;
    }
    .next-btn {
        width: 100%;
        height: 48px;
        border-radius: 500px;
        background-color: ${(p) => p.themeColor};
        color: white;
    }
`;

const StyledStep3 = styled.div<{ themeColor: string }>`
    .box-image {
        margin: 30px 30px;
        background-color: ${(p) => p.themeColor}20;
        border-radius: 20px;
        text-align: center;
        border: 1px dashed ${(p) => p.themeColor};
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        .dont-have-img {
            margin: 40px 20px;
            cursor: pointer;
        }
        svg {
            margin-bottom: 10px;
        }
        .have-img {
            margin: 8px;
            img {
                max-width: 95%;
                max-height: 125px;
            }
        }
        .color-span {
            color: ${(p) => p.themeColor};
        }
    }
    .confirm-btn {
        width: 100%;
        height: 48px;
        border-radius: 500px;
        background-color: ${(p) => p.themeColor};
        color: white;
    }
`;

const StyleStep4 = styled.div<{ themeColor: string }>`
    text-align: center;
    p {
        margin-top: 30vh;
        color: ${(p) => p.themeColor};
        font-size: 30px;
    }
    button {
        width: 50%;
        height: 48px;
        margin-top: 20px;
        border-radius: 500px;
        background-color: ${(p) => p.themeColor};
        color: white;
    }
`;

const StyleStep0 = styled.div<{ themeColor: string }>`
    padding: 20px;
    padding-top: 50px;
    h1 {
        font-size: 20px;
        text-align: center;
        color: ${(p) => p.themeColor};
    }
    .list-section {
        margin: 20px 0;
        .list-item {
            color: ${(p) => p.themeColor};
            background-color: #f4f4f4;
            margin: 10px 0;
            padding: 20px;
            cursor: pointer;
            border-radius: 8px;
        }
    }
`;
